module.exports = __webpack_public_path__ + "static/media/bubles.bdbf4a82.png";